<template>
  <b-container id="body-container" fluid>
    <b-row class="justify-content-center mb-5">
      <b-col cols="10">

        <b-row align-h="start" align-v="center" class="header-text-container">
          <b-col cols="10" md="6">
            <span>
              <h4 class="text-blackish title-body">Your Data Expert Hosts</h4>
            </span>
          </b-col>
          <b-col cols="2" md="3">
            <div class="color-design"></div>
          </b-col>
        </b-row>
        <b-row >
          <b-col
            v-for="guest of yourDataGuys"
            :key="guest.id"
            md="6"
            class="mt-md-4"
          >
            <HostCard :guest="guest" />
          </b-col>
        </b-row>


        <b-row align-h="start" align-v="center" class="header-text-container">
          <b-col cols="10" md="6">
            <span>
              <h4 class="text-blackish title-body">Your Sales Guru Co-hosts</h4>
            </span>
          </b-col>
          <b-col cols="2" md="3">
            <div class="color-design"></div>
          </b-col>
        </b-row>
        <b-row class="pb-5">
          <b-col
            v-for="guest of yourSalesGurus"
            :key="guest.id"
            md="6"
            class="mt-md-4"
          >
            <HostCard :guest="guest" />
          </b-col>
        </b-row>


        <b-row align-h="start" align-v="center" class="header-text-container">
          <b-col cols="10" md="6">
            <span>
              <h4 class="text-blackish title-body">Featured Speakers</h4>
            </span>
          </b-col>
          <b-col cols="2" md="3">
            <div class="color-design"></div>
          </b-col>
        </b-row>


        <b-row
                v-if="liveRightNow"
                align-h="start" align-v="center" class="header-text-container">
          <b-col cols="8" md="3">
            <span>
              <h4 class="text-blackish title-body">Live Now</h4>
            </span>
            <!--
            <span v-else>
              <h4 class="text-blackish title-body">Live Soon</h4>
            </span>
            -->
          </b-col>
          <b-col cols="4" md="3">
            <div class="color-design"></div>
          </b-col>
        </b-row>
        <div class="decorator1">
          <img alt="gravity logo" src="../../assets/decorator1.png" />
        </div>
        <MainCard :liveStream="liveStream" />
        <b-row align-h="start" class="header-text-container">
          <b-col md="5">
            <button
              :class="{ inactive: speakerSelection !== 1 }"
              @click.prevent="setSpeakerSelection(1)"
            >
              <h4 class="text-blackish title-body" id="upcoming">Upcoming Guests ({{ futureLen }})</h4>
            </button>
          </b-col>
          <b-col md="5">
            <button
              :class="{ inactive: speakerSelection !== 0 }"
              @click.prevent="setSpeakerSelection(0)"
            >
              <h4 class="text-blackish title-body">Past Guests ({{ pastLen }})</h4>
            </button>
          </b-col>
        </b-row>

        <span v-if="speakerSelection === 1">
          <b-row md="4">
            <b-col
              v-for="guest of futureSpeakers"
              :key="guest.id"
              md="6"
              class="mt-md-4"
            >
              <GuestCard :guest="guest" />
            </b-col>
          </b-row>
        </span>
        <span v-else>
          <b-row>
            <b-col
              v-for="guest of pastSpeakersSortedList"
              :key="guest.id"
              md="6"
              class="mt-md-4"
            >
              <PastGuestCard :guest="guest" />
            </b-col>
          </b-row>
        </span>

        <div class="decorator2">
          <img alt="gravity logo" src="../../assets/decorator2.png" />
        </div>
      </b-col>
    </b-row>

    <b-row>
          <b-col>

          </b-col>
    </b-row>

    <b-row id="launch-today-container" class="justify-content-center live-now">
      <b-col md="10">
        <b-row align-h="start" align-v="center" class="header-text-container">
          <b-col cols="12" md="12">
            <span>
              <h4 class="text-blackish title-body" style="text-align:center; color:white">A community of Top Sales Performers like you.</h4>
            </span>
            <span>
              <b-row align-v="center" align-h="center">
                <h6 class="text-blackish" style="text-align:center; color:white; opacity: 0.5;">a community by</h6>
                <a href="/">
                  <img alt="gravity logo" src="../../assets/logo-150.png" />
                </a>
              </b-row>
            </span>
          </b-col>
        </b-row>

        <b-row class="justify-content-center">
          <b-col md="5" cols="12" class="buttons-center" >
            <a
              href="https://www.facebook.com/groups/themastersofmarketing/"
              class="d-flex justify-content-center"
            >
              <b-button class="free-trial-button">Join the community</b-button>
            </a>

            <!--
            <a
              href="https://www.launchgravity.com/masters-of-marketing/#upcoming"
              class="d-flex justify-content-center"
            >
              <b-button class="button-white-transparen"><b>Check our events</b></b-button>
            </a>
            -->
          </b-col>
        </b-row>
      </b-col>
    </b-row>


  </b-container>
</template>

<style scoped lang="sass">
@import @/sass/screens/masters-of-marketing/body.sass
@import @/sass/_components/main-card.sass
@import @/sass/screens/home/header.sass
</style>

<script>
// components
import MainCard from '@/components/mainCard'
import GuestCard from '@/components/guestCard'
import HostCard from '@/components/hostCard'
import PastGuestCard from '@/components/pastCrushGuestCard'
// data
import { guests, yourDataGuys,yourSalesGurus } from '@/data/crush-your-quota.js'
import moment from 'moment'

export default {
  name: 'Body',
  components: {
    MainCard,
    GuestCard,
    HostCard,
    PastGuestCard,
  },
  data: function() {
    return {
      liveStream: {},
      featureSpeaker: [],
      pastSpeakers: [],
      futureSpeakers: [],
      pastSpeakersSortedList: [],
      guests,
      yourSalesGurus,
      yourDataGuys,
      timeToShow: 10,
      timer: null,
      currentDate: null,
      dayOfWeek: null,
      month: 1,
      day: 1,
      year: 2020,
      speakerSelection: 1,
      liveRightNow: 0,
      pastLen: 0,
      futureLen: 0,
    }
  },
  computed: {
    timeLeft() {
      return `${this.minutes} m ${this.seconds} seconds`
    },
    minutes() {
      return String(Math.floor(this.time / 60)).padStart(2, '0')
    },
    seconds() {
      return String(this.time % 60).padStart(2, '0')
    }
  },
  created() {
    this.orderSpeakers()
    this.setSpeakerRoles()
    this.pastSpeakersSorted()
    //this.timeToShow = this.getTimeToShow(),
    //this.timer = setInterval(this.decrement, 1000)
  },
  methods: {
    orderSpeakers() {
      var currentDate = new Date()
    
      for(var i in this.guests){
        var guestItem = this.guests[i]

        var speakingDate = guestItem.speakingDate
        var year = parseInt(speakingDate.substr(0, 4))
        var month = parseInt(speakingDate.substr(5, 6)) - 1
        var day = parseInt(speakingDate.substr(8, 9))
        var speakerDate = new Date(year, month, day, 0, 0, 0)
        var timeLeft = ((speakerDate - currentDate) / 86400000) + 0.416
        // var daysLeft = Math.ceil(timeLeft)

        // Store the dates back into the array
        guestItem.daysLeft = timeLeft
        var datePretty = speakerDate.toString().substr(0, 10)
        var ending = [
          '',
          'st',
          'nd',
          'rd',
          'th',
          'th',
          'th',
          'th',
          'th',
          'th',
          'th',
          'th',
          'th',
          'th',
          'th',
          'th',
          'th',
          'th',
          'th',
          'th',
          'st',
          'nd',
          'rd',
          'th',
          'th',
          'th',
          'th',
          'th',
          'th',
          'th',
          'st',
        ]
        if (ending[day] !== undefined) {
          datePretty += ending[day]
        } else {
          datePretty += 'th'
        }
        guestItem.datePretty = datePretty
        if (timeLeft < 1 && timeLeft > -0.082) {
          //this.featuredSpeaker = index
          guestItem.speakerStatus = 1 // featured
        } else if (timeLeft < 3 && (datePretty.substr(0, 3) === 'Mon') && timeLeft > -0.082) {
          guestItem.speakerStatus = 1 // featured
        } else if (timeLeft < -0.041) {
          guestItem.speakerStatus = 0 // past
        } else {
          guestItem.speakerStatus = 2 // future
        }

        if (timeLeft < -0.041 && timeLeft > -0.082) {
          this.liveRightNow = 1
        }
      }
    },
    pastSpeakersSorted(){
      this.pastSpeakersSortedList = this.pastSpeakers.sort(function(a,b){ 
        var keyA = moment(a.speakingDate, "YYYY-MM-DD"),
        keyB = moment(b.speakingDate, "YYYY-MM-DD");

        if(keyA > keyB) return -1;
        if(keyA < keyB) return 1;
        return 0;
      });
    },
    setSpeakerSelection(page) {
      this.speakerSelection = page
    },
    setSpeakerRoles() {
      for (var i = 0; i < this.guests.length; i++) {
        if (this.guests[i].speakerStatus === 1) {
          console.log('Speaker Status')
          console.log(this.guests[i].speakerStatus)
          this.featureSpeaker.push(this.guests[i])
        } else if (this.guests[i].speakerStatus === 2) {
          this.futureSpeakers.push(this.guests[i])
        } else {
          this.pastSpeakers.push(this.guests[i])
        }
        this.liveStream = this.featureSpeaker[0]
      }
      this.pastLen = this.pastSpeakers.length
      this.futureLen = this.futureSpeakers.length
    },

    getTimeToShow() {
      // Get the day of the week = 2
      this.dayOfWeek
      // Get the current time = in date object
      this.currentDate
      // Make sure the timezone is correct

      // Timezone varies depending on Daylight Savings

      // Compare with current time in timezone SF
      // var pacificTime = new Date("2020-04-13T00:00:00.000+08:00")

      // Get Time Until 10:30 AM PST
      // If time before 10:30am PST
      // If time 10:30 - 11           M-F (Skip) Show LIVE NOW
      // If time after 11 am PST      Subtract Hours from 24

      // If Monday,Tuesday,Wed,Thurs

      // If Friday Afternoon

      // If Saturday    Add + 2 days

      // If Sunday morning      Add + 1 day (Afternoon subtract from 24)

      // If
      // If between 10:30 - 11:00 Monday - Friday (Skip) Show LIVE NOW
      //
    },
    decrement() {
      this.time = this.time - 1
    },
  },
}
</script>
